import { Light } from "themes"
import { Themes } from "utils";

const CurrentTheme = Light;
const DefaultTheme = Themes.defaultTheme(CurrentTheme);
const ConvertToPixels = (value: number) => `${value}px`;
const CalculateFactor = (value: number) => ConvertToPixels(value * CurrentTheme.spacing.factor);

export const body = {
  margin: "0",
  border: "0",
  width: "100%",
  outline: "none",
  fontStyle: "normal",
  boxSizing: "border-box",
  fontOpticalSizing: "auto",
  fontFamily: DefaultTheme.typography.fontFamily,
} as React.CSSProperties

export const button = {
  width: "200px",
  display: "block",
  textAlign: "center",
  color: CurrentTheme.color.accent.text,
  borderRadius: CurrentTheme.border.circle,
  fontSize: ConvertToPixels(CurrentTheme.font.sm),
  backgroundColor: CurrentTheme.color.accent.color,
  marginTop: CalculateFactor(CurrentTheme.spacing.md),
  paddingTop: CalculateFactor(CurrentTheme.spacing.md),
  paddingLeft: CalculateFactor(CurrentTheme.spacing.lg),
  marginBottom: CalculateFactor(CurrentTheme.spacing.lg),
  paddingRight: CalculateFactor(CurrentTheme.spacing.lg),
  paddingBottom: CalculateFactor(CurrentTheme.spacing.md),
} as React.CSSProperties

export const column = {
  paddingLeft: CalculateFactor(CurrentTheme.spacing.md),
  paddingRight: CalculateFactor(CurrentTheme.spacing.md),
}

export const content = {
  paddingTop: CalculateFactor(CurrentTheme.spacing.xs),
  paddingLeft: CalculateFactor(CurrentTheme.spacing.xl),
  paddingRight: CalculateFactor(CurrentTheme.spacing.xl),
  paddingBottom: CalculateFactor(CurrentTheme.spacing.xs)
}

export const footer = {
  content: {
    textAlign: "center",
    color: CurrentTheme.color.primary.text,
    padding: CalculateFactor(CurrentTheme.spacing.xl),
    backgroundColor: CurrentTheme.color.primary.color,
    marginTop: CalculateFactor(CurrentTheme.spacing.md),
    borderTopLeftRadius: ConvertToPixels(CurrentTheme.border.circle),
    borderTopRightRadius: ConvertToPixels(CurrentTheme.border.circle),
  } as React.CSSProperties,
  divider: {
    display: "inline-block",
    borderTopColor: CurrentTheme.color.border.color,
    marginTop: CalculateFactor(CurrentTheme.spacing.md),
  },
  text: {
    fontWeight: CurrentTheme.font.medium,
    fontSize: ConvertToPixels(CurrentTheme.font.sm),
  }
}

export const footnote = {
  content: {
    borderWidth: "1px",
    textAlign: "center",
    borderStyle: "solid",
    borderColor: CurrentTheme.color.primary.color,
    padding: CalculateFactor(CurrentTheme.spacing.xl),
    marginTop: CalculateFactor(CurrentTheme.spacing.md),
    borderRadius: ConvertToPixels(CurrentTheme.border.circle),
  } as React.CSSProperties,
  column: {
    width: "33.33%",
    paddingLeft: CalculateFactor(CurrentTheme.spacing.xl),
    paddingRight: CalculateFactor(CurrentTheme.spacing.xl),
  },
  header: {
    marginTop: CalculateFactor(CurrentTheme.spacing.md),
    fontWeight: CurrentTheme.font.bold,
    fontSize: ConvertToPixels(CurrentTheme.font.md),
  },
  note: {
    color: CurrentTheme.color.font.accent,
    fontWeight: CurrentTheme.font.semiBold,
    fontSize: ConvertToPixels(CurrentTheme.font.sm),
  }
}

export const img = {
  width: "100%",
  boxSizing: "border-box",
  padding: CalculateFactor(CurrentTheme.spacing.sm),
} as React.CSSProperties

export const link = {
  textDecoration: "none",
  fontWeight: CurrentTheme.font.semiBold,
  color: CurrentTheme.color.accent.color,
}

export const row = {
  marginTop: CalculateFactor(CurrentTheme.spacing.md),
  marginButton: CalculateFactor(CurrentTheme.spacing.md),
}

export const schedule = {
  content: {
    width: "200px",
    margin: "unset",
  },
  tr: {
    lineHeight: "48px",
  },
  th: {
    fontWeight: CurrentTheme.font.semiBold,
    fontSize: ConvertToPixels(CurrentTheme.font.xs),
  },
  td: {
    textAlign: "right",
    color: CurrentTheme.color.font.accent,
    fontSize: ConvertToPixels(CurrentTheme.font.xs),
  } as React.CSSProperties
}

export const text = {
  fontWeight: CurrentTheme.font.normal,
  color: CurrentTheme.color.font.accent,
  fontSize: ConvertToPixels(CurrentTheme.font.xs),
}

export const textBold = {
  ...text,
  fontWeight: CurrentTheme.font.bold,
  color: CurrentTheme.color.font.color,
}

export const thumb = {
  width: "120px",
  height: "120px",
  margin: "0 auto",
}